import * as React from 'react';

type LoadingSkeletonProps = {
  count?: number;
};

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ count = 2 }) => (
  <div className="space-y-10">
    {[...Array(count)].map((_, index) => (
      <div key={index} className="px-5">
        <div className="flex w-full justify-between animate-pulse">
          <div className="flex items-top space-x-4">
            <div className="h-10 aspect-1 bg-gray-light rounded-md"></div>
            <div className="h-3 w-16 bg-gray-light rounded mt-1"></div>
          </div>
          <div className="flex flex-col items-end space-y-2">
            <div className="h-3 w-24 bg-gray-light rounded"></div>
            <div className="h-3 w-24 bg-gray-light rounded"></div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default LoadingSkeleton;
